import BaseDialogHtml from "../BaseDialog/BaseDialogHtml.js";
import {safeHtml} from "../../js/util/CommonUtils.js";

export default class BulkOperationWarningDialogCmp {
    #html = new BaseDialogHtml();

    /**
     * @param accessibleResources
     * @param inaccessibleResources
     */
    show(accessibleResources, inaccessibleResources) {
        this.#html.show({
            title: "Bulk operation warning",
            bodyHtml: this.#getBodyHtml(accessibleResources, inaccessibleResources),
            cssClass: "bulk-operation-warning-dialog",
            btnOk: accessibleResources.length === 0 ? null : "Continue",
            btnCancel: "Cancel"
        });
        this.#setEventListeners();
    }

    onOk(callback) {
        this.#html.onOk(callback);
    }
    onClose(callback) {
        this.#html.onCancel(callback);
    }

    close(){
        this.#html.close();
    }

    /**
     *
     * @param {InjectionMetaJson[]|BatchMeta[]} accessibleResources
     * @param {InjectionMetaJson[]|BatchMeta[]} inaccessibleResources
     * @returns {string}
     */
    #getBodyHtml(accessibleResources, inaccessibleResources) {
        const total = accessibleResources.length + inaccessibleResources.length;
        const list = BulkOperationWarningDialogCmp.#createListEntries(accessibleResources, inaccessibleResources);
        const visibleListHtml = `<ul>${list.slice(0, BulkOperationWarningDialogCmp.#VISIBLE_ELEMENTS_COUNT).join('')}</ul>`;
        const hiddenListElements = list.slice(BulkOperationWarningDialogCmp.#VISIBLE_ELEMENTS_COUNT).join('');
        let optionalListHtml = '';
        let footerHtml = '';
        if (accessibleResources.length > 0)
            footerHtml = `<span>If you continue, only accessible resources will be updated.</span>`;
        if (hiddenListElements.length > 0) {
            optionalListHtml = `<a id="show-more" href="">Show more</a>
                            <ul class="visually-hidden">
                                ${hiddenListElements}
                            </ul>`;
        }
        return `
            <div class="dialog-content">
                    <div class="dialog-row">
                        <span>Can't perform operation on ${inaccessibleResources.length} out of ${total} resources, insufficient permissions:</span>
                    </div>
                    <div class="dialog-row">
                        ${BulkOperationWarningDialogCmp.#SVG_DEFS + visibleListHtml + optionalListHtml}
                    </div>
                    <div class="dialog-row">
                        ${footerHtml}
                    </div>
                </div>`;
    }

    #setEventListeners() {
        const showMoreButton = this.#html.getElement('#show-more');
        if (showMoreButton)
            showMoreButton.addEventListener('click', this.#onShowMoreButtonClick.bind(this));
    }

    #onShowMoreButtonClick(evt) {
        evt.preventDefault();
        this.#html.getElement('ul.visually-hidden').classList.remove('visually-hidden');
        this.#html.getElement('#show-more').remove();
    }

    /**
     *
     * @param {InjectionMetaJson[]|BatchMeta[]} accessibleResources
     * @param {InjectionMetaJson[]|BatchMeta[]} inaccessibleResources
     * @returns {*}
     */
    static #createListEntries(accessibleResources, inaccessibleResources) {
        const arr1 = accessibleResources.map((name) => {
            return safeHtml`<li>
                        <span title="You have access to this resources">
                            <svg fill-opacity=".7" viewBox="0 0 24 24" width="18px">
                                <use href="#accessible"></use>
                            </svg>			
					    </span>
					    <span>${name}</span>
				</li>`
        });
        const arr2 = inaccessibleResources.map((name) => {
            return safeHtml`<li>
                        <span title="You don't have access to this resources">
                            <svg fill-opacity=".7" viewBox="0 0 24 24" width="18px">
                                <use href="#inaccessible"></use>
                            </svg>			
					    </span>
					    <span>${name}</span>
				</li>`
        });
        return arr2.concat(arr1);
    }

    static #VISIBLE_ELEMENTS_COUNT = 3;
    static #SVG_DEFS = `
        <svg style="display: none">
            <defs>
                <g fill="rgb(0,128,0)" id="accessible">
                    <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z"></path>
                </g>
                <g fill="rgb(207,42,39)" id="inaccessible">
                    <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-2h2v2zm0-4h-2V7h2v6z"></path>
                </g>
            </defs>
        </svg>`;
}